import { configureStore } from '@reduxjs/toolkit';
import sidenavReducer from './sidenavSlice';
import saReducer from './SASlice';

export default configureStore({
  reducer: {
    sidenav: sidenavReducer,
    sa: saReducer,
  },
});